export const DEFAULT_CAUCUS_TIME_SECONDS = 10 * 60;
export const DEFAULT_SPEAKER_TIME_SECONDS = 1 * 60;